import React, { createContext, useState, useEffect } from 'react';
import { db } from '../../Firebase/firebase';
import {
  onSnapshot,
  collection,
  query,
  where,
  getDoc,
  doc,
  updateDoc
} from 'firebase/firestore';
import { countriesList } from '../../Data/pageData.jsx';
import { getStorage, ref, getDownloadURL } from 'firebase/storage'; // Import Firebase functions
import { CircularProgress } from '@mui/material';

export const PostsContext = createContext();

//Handles state and functions relating to fetching posts from firebase
export const PostsProvider = ({ children, categories }) => {
  const [categoriesData, setCategoriesData] = useState({});
  const [loading, setLoading] = useState(true);
  // const [adPostsData, setAdPostsData] = useState([]); // For advertisement posts
  // const defaultCountry = countriesList.find(
  //   (country) => country.label === 'Ecuador'
  // );
  //const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [xploras360Image, setXploras360Image] = useState('./images/siteImages/xploras360.png'); // State to store the logo Image URL
  const [dashboardImage, setDashboardImage] = useState(''); // State to store the dashboard image URL
  const [defaultAvatarImage, setDefaultAvatarImage] = useState('');

  // useEffect(() => {
  //   const fetchImage = async () => {
  //     const storage = getStorage(); // Initialize Firebase Storage
  //     const imageRef = ref(storage, 'siteImages/xploras360.png'); // Reference to the image in Firebase

  //     try {
  //       const url = await getDownloadURL(imageRef); // Get the image URL
  //       setXploras360Image(url); // Update the state with the URL
  //     } catch (error) {
  //       console.error('Error fetching xploras360 image:', error); // Handle errors
  //     }

  //     // Fetch dashboard design image
  //     const dashboardImageRef = ref(storage, 'siteImages/dashboardDesign.png');
  //     try {
  //       const dashboardUrl = await getDownloadURL(dashboardImageRef);
  //       setDashboardImage(dashboardUrl); // Update the state with the dashboard image URL
  //     } catch (error) {
  //       console.error('Error fetching dashboard design image:', error);
  //     }
  //     // Fetch dashboard design image
  //     const defaultAvatarImageRef = ref(
  //       storage,
  //       'siteImages/defaultAvatar.jpg'
  //     );
  //     try {
  //       const defaultAvatarURL = await getDownloadURL(defaultAvatarImageRef);
  //       setDefaultAvatarImage(defaultAvatarURL); // Update the state with the dashboard image URL
  //     } catch (error) {
  //       console.error('Error fetching default Avatar image:', error);
  //     }
  //   };

  //   fetchImage();
  // }, []);

  useEffect(() => {
    const fetchImage = async () => {
      const storage = getStorage();
      try {
        const [xplorasUrl, dashboardUrl, defaultAvatarURL] = await Promise.all([
          getDownloadURL(ref(storage, 'siteImages/xploras360.png')),
          getDownloadURL(ref(storage, 'siteImages/dashboardDesign.png')),
          getDownloadURL(ref(storage, 'siteImages/defaultAvatar.jpg'))
        ]);
        setXploras360Image(xplorasUrl);
        setDashboardImage(dashboardUrl);
        setDefaultAvatarImage(defaultAvatarURL);
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImage();
  }, []);

  // useEffect(() => {
  //   const unsubscribe = [];
  //   //ddefining the fetchCategoryData
  //   const fetchCategoryData = (category) => {
  //     try {
  //       const q = query(
  //         collection(db, 'posts'),
  //         where('category', '==', category)
  //       );
  //       return onSnapshot(q, (querySnapshot) => {
  //         const postsData = [];
  //         querySnapshot.forEach((doc) => {
  //           postsData.push({ ...doc.data(), id: doc.id });
  //         });
  //         setCategoriesData((prevData) => ({
  //           ...prevData,
  //           [category]: postsData,
  //         }));
  //       });
  //     } catch (error) {
  //       console.error(
  //         `Error fetching posts for category "${category}":`,
  //         error
  //       );
  //       return () => {}; // Return a no-op function if an error occurs
  //     }
  //   };

  //   //running the fetchCategoryData
  //   categories.forEach((category) => {
  //     unsubscribe.push(fetchCategoryData(category));
  //   });

  //   setLoading(false);

  //   // Cleanup on unmount
  //   return () => {
  //     unsubscribe.forEach((unsub) => unsub());
  //   };
  // }, [categories]);


  useEffect(() => {
    const unsubscribe = [];
   

    const fetchCategoryData = (category) => {
      try {
        const q = query(collection(db, "posts"), where("category", "==", category));
        return onSnapshot(q, async (querySnapshot) => {
          let postsData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    
          // Identify posts missing user data
          const postsNeedingUpdate = postsData.filter(
            // (post) => !post.username || !post.name || !post.email || !post.photoURL
            (post) => !post.username || post.username === "" || 
            !post.name || post.name === "" || 
            !post.email || post.email === "" || 
            !post.userPhotoURL || post.userPhotoURL === ""
          );
    
          if (postsNeedingUpdate.length > 0) {
            const userFetchPromises = postsNeedingUpdate.map(async (post) => {
              if (!post.userId) return post; // If no userId, return post as is
    
              try {
                const userDoc = await getDoc(doc(db, "users", post.userId));
                if (userDoc.exists()) {
                  const userData = userDoc.data();
                  const updatedPost = {
                    ...post,
                    username: post.username || userData.username || "Unknown",
                    name: post.name || userData.name || "No Name",
                    email: post.email || userData.email || "No Email",
                    userPhotoURL: post.userPhotoURL || userData.photo || defaultAvatarImage,
                  };
    
                  // ✅ **Write updated data back to Firestore**
                  await updateDoc(doc(db, "posts", post.id), {
                    username: updatedPost.username,
                    name: updatedPost.name,
                    email: updatedPost.email,
                    photoURL: updatedPost.photoURL,
                    userPhotoURL: updatedPost.userPhotoURL,
                  });
    
                  return updatedPost;
                }
              } catch (error) {
                console.error(`Error fetching user data for post ${post.id}:`, error);
              }
              return post; // Return the original post if user fetch fails
            });
    
            // Wait for all updates
            const updatedPosts = await Promise.all(userFetchPromises);
    
            // Merge updated posts into original dataset
            postsData = postsData.map((post) =>
              updatedPosts.find((updatedPost) => updatedPost.id === post.id) || post
            );
          }
    
          setCategoriesData((prevData) => ({
            ...prevData,
            [category]: postsData,
          }));
        });
      } catch (error) {
        console.error(`Error fetching posts for category "${category}":`, error);
        return () => {};
      }
    };
    
    // const fetchCategoryData = (category) => {
    //   try {
    //     const q = query(collection(db, "posts"), where("category", "==", category));
    //     return onSnapshot(q, async (querySnapshot) => {
    //       let postsData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    //       // Identify posts missing user data
    //       const postsNeedingUpdate = postsData.filter(
    //         //(post) => post.username === "" || post.name === "" || post.email === ""|| post.photoURL === ""
    //         (post) => !post.username || post.username === "" || 
    //         !post.name || post.name === "" || 
    //         !post.email || post.email === "" || 
    //         !post.photoURL || post.photoURL === ""
    //       );
    //       console.log("posts needing update are - ",postsNeedingUpdate)

    //       if (postsNeedingUpdate.length > 0) {
    //         const userFetchPromises = postsNeedingUpdate.map(async (post) => {
    //           if (!post.userId) return post; // If no userId, return post as is

    //           try {
    //             const userDoc = await getDoc(doc(db, "users", post.userId));
    //             if (userDoc.exists()) {
    //               const userData = userDoc.data();
    //               const updatedPost = {
    //                 ...post,
    //                 username: post.username || userData.username || "Unknown",
    //                 name: post.name || userData.name || "No Name",
    //                 email: post.email || userData.email || "No Email",
    //                 photoURL: post.photoURL || userData.photo || defaultAvatarImage,
    //               };
    
    //               // ✅ **Write updated data back to Firestore**
    //               await updateDoc(doc(db, "posts", post.id), {
    //                 username: updatedPost.username,
    //                 name: updatedPost.name,
    //                 email: updatedPost.email,
    //                 photoURL: updatedPost.photoURL,
    //               });
    
    //               return updatedPost;
    //               // return {
    //               //   ...post,
    //               //   username: post.username || userData.username || "Unknown",
    //               //   name: post.name || userData.name || "No Name",
    //               //   email: post.email || userData.email || "No Email",
    //               //   photoURL: post.photoURL || userData.photo || defaultAvatarImage,
    //               // };
    //             }
    //           } catch (error) {
    //             console.error(`Error fetching user data for post ${post.id}:`, error);
    //           }
    //           return post; // Return the original post if user fetch fails
    //         });

    //         // Wait for all user fetches to complete
    //         const updatedPosts = await Promise.all(userFetchPromises);
            
    //         // Merge updated posts into original dataset
    //         postsData = postsData.map((post) => 
    //           updatedPosts.find((updatedPost) => updatedPost.id === post.id) || post
    //         );
    //       }

    //       setCategoriesData((prevData) => ({
    //         ...prevData,
    //         [category]: postsData,
    //       }));
    //     });
    //   } catch (error) {
    //     console.error(`Error fetching posts for category "${category}":`, error);
    //     return () => {}; 
    //   }
    // };

    categories.forEach((category) => {
      unsubscribe.push(fetchCategoryData(category));
    });

    setLoading(false);

    return () => {
      unsubscribe.forEach((unsub) => unsub());
    };
  }, [categories, defaultAvatarImage]);


  if (loading) {
    return <CircularProgress />; // Show a loading indicator while fetching
  }

  return (
    <PostsContext.Provider
      value={{
        categoriesData,
        // adPostsData,
        loading,
        // selectedCountry,
        // setSelectedCountry,
        xploras360Image,
        dashboardImage,
        defaultAvatarImage,
      }}
    >
      {children}
    </PostsContext.Provider>
  );
};

//Ad posting removed for now, may create Ad context for ads when I start sharing ads:
 // // Fetch advertisement posts
    // const fetchAdPosts = () => {
    //   try {
    //     const q = query(collection(db, 'AdPosts'));
    //     const unsub = onSnapshot(q, (querySnapshot) => {
    //       const adPosts = [];
    //       querySnapshot.forEach((doc) => {
    //         adPosts.push({ ...doc.data(), id: doc.id });
    //       });
    //       setAdPostsData(adPosts);
    //     });
    //     unsubscribe.push(unsub);
    //   } catch (error) {
    //     console.error('Error fetching advertisement posts:', error);
    //   }
    // };

    // fetchAdPosts();

